import { useEffect } from "react";

let autocompleteService, placeService;

export default function useAddressSearch() {
  useEffect(() => {
    autocompleteService = new google.maps.places.AutocompleteService();
    const placeContainer = document.getElementById("place-container");
    placeService = new google.maps.places.PlacesService(placeContainer);
  }, []);

  const getPlacePredictions = (address, callback) => {
    autocompleteService.getPlacePredictions(
      { input: address },
      (predictions, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          callback(
            predictions.map((item) => ({
              id: item.place_id,
              label: item.description,
            }))
          );
        } else {
          callback([]);
        }
      }
    );
  };

  const getPlaceDetails = (placeId, callback) => {
    const request = {
      placeId: placeId,
      fields: ["name", "geometry", "formatted_address"],
    };

    placeService.getDetails(request, async (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const lat = place.geometry.location.lat();
        const lon = place.geometry.location.lng();
        const elev = await getLocationElevation(lat, lon);
        callback({ lat, lon, elev });
      } else {
        console.error("Place details request failed:", status);
        callback({ });
      }
    });
  };

  const getLocationElevation = async (lat, lon) => {
    const elevator = new google.maps.ElevationService();
    const latLng = new google.maps.LatLng(lat, lon);

    try {
      const { results } = await elevator.getElevationForLocations({
        locations: [latLng],
      });

      return results.length > 0 ? results[0].elevation : null;

    } catch (e) {
      console.error("Error on elevation service: ", e);
      return null;
    }
  };

  return {
    getPlacePredictions,
    getPlaceDetails,
  };
}
